import { lazy } from "react";

const routes = [
  {
    path: "/settings/personalization",
    element: lazy(() => import("../../pages/Settings/Personalization")),
  },
];

export default routes;
